module.exports = __webpack_public_path__ + "static/media/focus.aaa0b62d.png";


//////////////////
// WEBPACK FOOTER
// ./src/marketingOnline/data/carImages/远程E200厢式车/focus.png
// module id = 712
// module chunks = 0